/** Do not edit directly **/
/** Do not edit directly **/
/**
 * @prop --sy-dialog-background-color: Dialog background color.
 * @prop --sy-dialog-border-color: Dialog border color.
 * @prop --sy-dialog-border-style: Dialog border style.
 * @prop --sy-dialog-border-radius: Dialog border radius.
 * @prop --sy-dialog-border-width: Dialog border width.
 * @prop --sy-dialog-box-shadow: Dialog box shadow.
 * @prop --sy-dialog-size-sm: Small dialog max-width.
 * @prop --sy-dialog-size-md: Medium dialog max-width.
 * @prop --sy-dialog-size-lg: Large dialog max-width.
 * @prop --sy-dialog-size-xl: Extra large dialog max-width.
 * @prop --sy-dialog-backdrop-background-color: Dialog backdrop background color.
 * @prop --sy-dialog-max-height: Dialog max height.
 * @prop --sy-dialog-max-width: Dialog max width.
 * @prop --sy-dialog-min-height: Dialog min height.
 * @prop --sy-dialog-min-width: Dialog min width.
 */
*,
:host,
*::before,
*::after {
  box-sizing: border-box;
}

:host {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
}

:host(:not([visible])) {
  display: none;
}

::backdrop {
  background-color: var(--sy-dialog-backdrop-background-color, rgba(0, 0, 0, 0.7));
}

sy-backdrop {
  --sy-backdrop-background-color: var(--sy-dialog-backdrop-background-color, rgba(0, 0, 0, 0.7));
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}
:host([position=absolute]) sy-backdrop {
  position: absolute;
}
:host([position=fixed]) sy-backdrop {
  position: fixed;
}

:host([hide-backdrop]) ::backdrop {
  background-color: transparent;
}
:host([hide-backdrop]) sy-backdrop {
  --sy-backdrop-background-color: transparent;
}

sy-focus-trap {
  display: flex;
  flex-direction: column;
  min-width: var(--sy-dialog-min-width, auto);
  max-width: var(--sy-dialog-max-width, calc(100% - var(--sy-spacer-6)));
  min-height: var(--sy-dialog-min-height, auto);
  max-height: var(--sy-dialog-max-height, calc(100% - var(--sy-spacer-6)));
}
sy-focus-trap > .sy-dialog {
  flex: 1;
  min-width: 100%;
  max-width: 100%;
  height: 100%;
  min-height: 100%;
  max-height: 100%;
}

dialog {
  padding: 0;
  overflow: visible;
  border: none;
  border-radius: var(--sy-dialog-border-radius, var(--sy-border-radius));
}

.sy-dialog {
  z-index: 1060;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: var(--sy-dialog-background-color, var(--sy-surface-elevated));
  border-radius: var(--sy-dialog-border-radius, var(--sy-border-radius));
}
.sy-dialog sy-dialog-content {
  overflow-y: auto;
}
:host([hide-backdrop]) .sy-dialog {
  border-color: var(--sy-dialog-border-color, var(--sy-border));
  border-style: var(--sy-dialog-border-style, solid);
  border-width: var(--sy-dialog-border-width, 1px);
  box-shadow: var(--sy-dialog-box-shadow, var(--sy-shadow-offset-x) var(--sy-shadow-offset-y) var(--sy-shadow-radius) var(--sy-shadow));
}
:host([hide-header]) .sy-dialog {
  padding-top: var(--sy-spacer-4);
}
:host([hide-footer]) .sy-dialog {
  padding-bottom: var(--sy-spacer-4);
}
@media (min-width: 576px) {
  .sy-dialog {
    width: var(--sy-dialog-size-sm, 300px);
  }
}
@media (min-width: 576px) and (min-width: 768px) {
  :host([dialog-size=medium]) .sy-dialog, :host([dialog-size=large]) .sy-dialog, :host([dialog-size=extra-large]) .sy-dialog {
    width: var(--sy-dialog-size-md, 500px);
  }
}
@media (min-width: 576px) and (min-width: 992px) {
  :host([dialog-size=large]) .sy-dialog, :host([dialog-size=extra-large]) .sy-dialog {
    width: var(--sy-dialog-size-lg, 800px);
  }
}
@media (min-width: 576px) and (min-width: 1200px) {
  :host([dialog-size=extra-large]) .sy-dialog {
    width: var(--sy-dialog-size-xl, 1140px);
  }
}
@media (min-width: 576px) {
  :host([dialog-size=full][position=absolute]) .sy-dialog {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    max-width: none;
    height: 100%;
    max-height: none !important;
    margin: 0;
    border-radius: 0;
  }
  :host([dialog-size=full][position=absolute]) .sy-dialog sy-dialog-content {
    overflow-y: auto;
  }
}
@media (min-width: 576px) {
  :host([dialog-size=full][position=fixed]) .sy-dialog {
    position: fixed;
    top: 0;
    right: 0;
    width: 100%;
    max-width: none;
    height: 100%;
    max-height: none !important;
    margin: 0;
    border-radius: 0;
  }
  :host([dialog-size=full][position=fixed]) .sy-dialog sy-dialog-content {
    overflow-y: auto;
  }
}
@media (max-width: 576px) {
  :host([position=absolute]) .sy-dialog {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    max-width: none;
    height: 100%;
    max-height: none !important;
    margin: 0;
    border-radius: 0;
  }
  :host([position=absolute]) .sy-dialog sy-dialog-content {
    overflow-y: auto;
  }
  :host([position=fixed]) .sy-dialog {
    position: fixed;
    top: 0;
    right: 0;
    width: 100%;
    max-width: none;
    height: 100%;
    max-height: none !important;
    margin: 0;
    border-radius: 0;
  }
  :host([position=fixed]) .sy-dialog sy-dialog-content {
    overflow-y: auto;
  }
}